<template lang="pug">
    .guest-layout
        layout-header
        .guest-layout__body
            .guest-layout__left
                .guest-layout__left-img
            .guest-layout__right
                slot
        layout-footer

</template>

<script>
export default {
    name: 'guest-layout',
}
</script>
